import React from 'react';

const Home = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Welcome to the Student Admission Portal</h1>
      <p>Your future starts here. Please use the navigation menu to register.</p>
    </div>
  );
};

export default Home;
